<!--<div class="container-fluid">-->

  <form id="self-information" [formGroup]="regForm" (ngSubmit)="step8Submitted(regForm)" novalidate>


    <div class="form-row">
      <label style="font-weight: bold; font-size: x-large;">Specialty Information</label>
    
    </div><br><br>
    

<div>
    

  <div class="form-group col-lg-12 col-sm-12 col-md-12" >

    <label>PLEASE SELECT THE BUTTONS THAT BEST MATCH YOUR EDUCATION,CREDENTIALS, AND EXPERIENCE:
    </label>

    <div class="form-row">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox"  id="HC" formControlName="HC" [checked]="regForm.get('HC').value=='Home Care'" value="Home Care" >
        <label class="form-check-label" for="yes">Home Care</label>
    </div><br>
    <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox"  id="EXTCARE" formControlName="EXTCARE" value="Extended Care" >
        <label class="form-check-label" for="yes">Extended Care</label>
    </div> 
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox"  id="SURG" formControlName="SURG" value="Med./Surg" >
      <label class="form-check-label" for="yes">Med./Surg</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="HOSPICE" formControlName="HOSPICE" value="Hospice" >
    <label class="form-check-label" for="yes">Hospice</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="MENTAL" formControlName="MENTAL" value="Mental Health" >
    <label class="form-check-label" for="yes">Mental Health</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="INTCARE" formControlName="INTCARE" value="Intermittent Care" >
    <label class="form-check-label" for="yes">Intermittent Care</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="ONCOLOGY" formControlName="ONCOLOGY" value="Oncology" >
    <label class="form-check-label" for="yes">Oncology</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="IV" formControlName="IV" value="IV Therapy" >
    <label class="form-check-label" for="yes">IV Therapy</label>
  </div>
  <!--<div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="PEDIATRIC" formControlName="PEDIATRIC" value="Pediatric" >
    <label class="form-check-label" for="yes">Pediatric</label>
  </div>-->   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="MATCHILD" formControlName="MATCHILD" value="Maternal Child" >
    <label class="form-check-label" for="yes">Maternal Child</label>
  </div>  
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="RESIDENTIAL" formControlName="RESIDENTIAL" value="Residential Care" >
    <label class="form-check-label" for="yes">Residential Care</label>
  </div>       
    </div>




    <div class="form-row">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox"  id="STAFF" formControlName="STAFF" value="Supplemental Staffing" >
        <label class="form-check-label" for="yes">Supplemental Staffing</label>
    </div><br>
    <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox"  id="GENERIC" formControlName="GENERIC" value="Generic" >
        <label class="form-check-label" for="yes">Generic</label>
    </div> 
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox"  id="HOSPITAL" formControlName="HOSPITAL" value="Hospital" >
      <label class="form-check-label" for="yes">Hospital</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="ICU" formControlName="ICU" value="ICU/CCU" >
    <label class="form-check-label" for="yes">ICU/CCU</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="LABOR" formControlName="LABOR" value="Labor/Delivery" >
    <label class="form-check-label" for="yes">Labor/Delivery</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="MEDSURG" formControlName="MEDSURG" value="Med./Surg." >
    <label class="form-check-label" for="yes">Med./Surg.</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="NURSING" formControlName="NURSING" value="Nursing Home" >
    <label class="form-check-label" for="yes">Nursing Home</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="PEDS" formControlName="PEDS" value="Pediatric" >
    <label class="form-check-label" for="yes">Pediatric</label>
  </div>
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="PRIVATE" formControlName="PRIVATE" value="Private Duty" >
    <label class="form-check-label" for="yes">Private Duty</label>
  </div>   
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="checkbox"  id="PSYCH" formControlName="PSYCH" value="Psychiatric" >
    <label class="form-check-label" for="yes">Psychiatric</label>
  </div>    
    </div>








    
    <div class="form-row" style="height:50px;"></div>

    <div class="form-row">

      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox"  id="CLINIC" formControlName="CLINIC" (change)="clinicClick($event)" value="Clinic" >
        <label class="form-check-label" for="yes">Clinic (Specify)</label>
      </div>   

      <div class="form-group  col-lg-7 col-sm-7 col-md-7" >
  
        <div class="form-check form-check-inline">
            <textarea class="form-control"  id="CLINIC21" for="CLINIC21" formControlName="CLINIC21" ></textarea>
        
        </div>
        
      </div>
  </div>

  <div class="form-row">
 

      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox"  id="OTHERSTAFF" formControlName="OTHERSTAFF" (change)="staffClick($event)" value="Other" >
        <label class="form-check-label" for="yes">Other Please Explain</label>
      </div>   
    
    <div class="form-group  col-lg-7 col-sm-7 col-md-7" >

      <div class="form-check form-check-inline">
          <textarea class="form-control"  id="OTHERSTAFF2" for="OTHERSTAFF2" formControlName="OTHERSTAFF2" ></textarea>
      
      </div>
      
    </div>
</div>


    </div>



  
</div>

    <br/>

        <button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>Prev Page</button>
    &nbsp;
    <button type="submit"  class="btn btn-primary" >Save and Continue &nbsp;
      <i className="ace-icon fa fa-arrow-right icon-on-right"></i></button>   

      
      <div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> Saving Data...</i>
    
  </form>

<!--</div>-->
  
  

  
  
  
